'use client';

import React from 'react';

import type { UserFollow, UserProfile as TypeUserProfile } from '@/types/user';

import UserContent from './content';
import UserInfomation from './info';

const UserProfile: React.FC<{
  user: TypeUserProfile;
  follow: UserFollow;
}> = ({ user, follow }) => {
  return (
    <div>
      <UserInfomation user={user} follow={follow} />
      <UserContent user={user} />
    </div>
  );
};

export default UserProfile;
